"use client";
import { apiClient } from "@/lib/client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { cookies } from "next/headers";

export default function ValidateSessionKey() {
  const router = useRouter();
  // biome-ignore lint:
  useEffect(() => {
    const validateSession = async () => {
      await apiClient.logout(undefined);
      await apiClient.v3accepted(undefined);
      router.refresh();
    };

    validateSession();
  }, []);

  return null;
}
